import { IconSearch } from "@tabler/icons-react";
import { useCallback } from "react";

import { Button } from "../../components/shared/Button/Button";
import { useGetApi } from "../../hooks";
import type { ISearchResult } from "../../pages/SearchPage/SearchPage.types";
import { useDispatch } from "../../redux/hooks";
import { setCaseReportModalData } from "../../redux/slices/generatorFeaturesSlice";
import { getYachtId } from "../../utils";

interface Props {
  caseNumber: string;
}

const CaseReportButton = ({ caseNumber }: Props) => {
  const dispatch = useDispatch();

  const mapper = useCallback(
    (data: { success: boolean; list: ISearchResult[] }) => {
      if (data?.success) {
        const parsedData = data.list.map((item: any) => ({
          ...item,
          lbname: "Medical Log",
        }));

        dispatch(setCaseReportModalData({ caseNumber, data: parsedData }));
      }
    },
    [caseNumber, dispatch],
  );

  const { refetch, isLoading } = useGetApi({
    request: "search-case-reports-entries",
    fetchOnInit: false,
    body: {
      params: {
        yachtid: getYachtId(),
        caseno: caseNumber,
      },
    },
    mapper,
  });

  const handleOpen = () => {
    if (caseNumber) void refetch();
  };

  if (window.api && !window.navigator.onLine) {
    return;
  }

  return (
    <Button
      variant="outline"
      onClick={handleOpen}
      loading={isLoading}
      rightIcon={<IconSearch />}
      disabled={!caseNumber}>
      Search entries
    </Button>
  );
};
export default CaseReportButton;
